import styled from "styled-components";
import ReadMore from "./ReadMore";
import {useContext, useMemo, useState} from "react";
import { SPEKTRA_BLUEPRINT, STATIC_BLUEPRINT, MAX_ENVS_PER_PARTNER_PER_DAY } from "../../../../../../../utils/const/createEnvConsts";
import DurationIcon from "../../../../../../assets/createEnvAssets/DurationIcon";
import DocsIcon from "../../../../../../assets/createEnvAssets/DocsIcon";
import PlayIcon from "../../../../../../assets/createEnvAssets/PlayIcon";
import EnvironmentContext from "../../EnvironmentContext";
import {useQuery} from "react-query";
import {demoEnv} from "../../../../../../../utils/const/query-key";
import apiService from "../../../../../../../api/apiService";
import { isSameDay } from "date-fns";
import NewBlueprintIcon from "../../../../../../assets/admin-env-assets/NewBlueprintIcon";
import UnderMaintenanceIcon from "../../../../../../assets/admin-env-assets/UnderMaintenanceIcon";

const ListStyle = styled.li`
  width: 590px;
  background: var(--color-workspace-bg-page-area);
  border-radius: 10px;
  margin-bottom: 8px;
  padding: 10px;
  cursor: pointer;
  list-style: none;
  border: 1px solid #e7e2e2;
  color: #666666;

  ${props => props.disabled ? 'pointer-events: none;' : ''}
  ${props => props.disabled ? ' opacity: 0.6;' : ''}
  
  &.selected {
    background: #FDEBF1;
    color: black;
    border: 1px solid #EC407A;

    .header_blueprint {
      color: #EC407A;
      font-weight: bold;
    }

    .icon_image {
      width: 20px;
    }
  }
  
  &:focus {
    background: #FDEBF1;
    color: black;
    border: 1px solid #EC407A;

    .header_blueprint {
      color: #EC407A;
      font-weight: bold;
    }

    .icon_image {
      width: 20px;
    }
  }

  .icon_image {
    width: 17px;
    margin: 0px 10px 12px 0px;
  }

  .header_blueprint {
    display: flex;
    font-size: small;
  }

  .icons {
    flex: 1;
    justify-content: end;
    display: flex;
    align-items: flex-start;
    white-space: nowrap;
      gap: 3px;
      margin-bottom: 5px;
  }

  .icon {
    display: flex;
    white-space: nowrap;
  }

  .separator {
    color: #e0d8d8;
  }
`;


const BluePrint = (props) => {
    const {name, description, bp, handleBlueprintClick, bpIcon, cloudTypeId, userData, selected} = props;
    const [expanded, setExpanded] = useState(true);
    const {environment} = useContext(EnvironmentContext);
    const {data} = useQuery(demoEnv, () =>
        apiService.getEnvironmentData(),
        { staleTime: Infinity}
    );


    const [disabled, tooltipMessage] = useMemo(() => {
        if (environment.is_invitation && ( cloudTypeId === STATIC_BLUEPRINT || cloudTypeId === SPEKTRA_BLUEPRINT) ) {
            return [true, "This environment is not available for user invitation"];
        }
        
        const envAlreadyActive = data?.some((env) => env.blueprintId === bp.id && env.status === "Ready");
        
        if (envAlreadyActive && !environment.is_invitation) {
            return [true, "This environment is already active"]
        }

        if (userData.isCpEmployee || !environment.is_invitation) return [false, ""];

        const invitationEnvsFromToday = data?.filter((env) =>
            env.blueprintId === bp.id &&
            env.status === "Invitation" &&
            isSameDay(new Date(), new Date(env.createdOn))
        );
        
        if (invitationEnvsFromToday?.length >= MAX_ENVS_PER_PARTNER_PER_DAY) {
            return [true, `You have reached the maximum number of invitations (${MAX_ENVS_PER_PARTNER_PER_DAY}) for today for this blueprint`]
        }

        return [false, ""];
    }, [environment, data, bp, cloudTypeId, userData]);

    return (
        <span className={name.split(' ').join('-')} title={tooltipMessage}>
            <ListStyle tabIndex={"0"} data-hint={"hey"} disabled={disabled} className={`${name.split(' ').join('-')} ${selected ? "selected" : ""}`}
                       onClick={() => handleBlueprintClick(bp.id, bp.category, bp.subPillar,name)}
                       setExpanded={setExpanded} expanded={expanded}>
                <span className={"select_blueprint"}>
                    <div className={"header_blueprint"}>
                        <img style={{ width: 20, height: 20}} className={"icon_image"} src={bpIcon} alt={bp.category} title={bp.category}/>
                        <span style={{ marginTop: 4, fontWeight:"bold"}}>{name}</span>
                        <span className={"icons"}>
                            {bp.isNew &&
                                <span className={"icon"}>
                                    <NewBlueprintIcon/>
                                </span>
                            }
                            {bp.isUnderMaintenance &&
                                <span className={"icon"}>
                                    <UnderMaintenanceIcon/>
                                </span>
                            }
                            {(bp.videoLink !== "" && bp.videoLink !== null) &&
                                <span className={"icon"} style={{ marginTop: 4 }}>
                                    <a href={bp.videoLink} target="_blank" rel="noreferrer" id={"video_link"}>
                                        <PlayIcon/>
                                    </a>
                                </span>
                            }
                            <a style={{ marginTop: 4 }} href={bp.userGuideLink} target="_blank" rel="noreferrer" id={"user_guide_link"}>
                                <DocsIcon/>
                            </a>
                            <span className={"icon"} style={{ marginTop: 4 }}>
                                <span className={"separator"}>|</span>
                                <DurationIcon/>
                                <span>{bp.duration} Hrs</span>
                            </span>
                        </span>
                    </div>
                    <ReadMore expanded={expanded} setExpanded={setExpanded}>
                        {description}
                    </ReadMore>
                </span>
            </ListStyle>
        </span>
    );

}
export default BluePrint;
